function restoreImport(uri, mediaQuery) {
  return ('@import ' + uri + ' ' + mediaQuery).trim();
}

module.exports = restoreImport;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/reader/restore-import.js
// module id = 1054
// module chunks = 0